import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import { StpApplicationDto } from '../../DTO/stp_application_dto.model';
import { RequestData } from '../../models/stp_onlinePayment.model';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { environment } from 'src/environments/environment';
import { CertificateService } from 'src/app/shared/services/certificate.service';

@Component({
  selector: 'app-application-list-stp',
  templateUrl: './application-list-stp.component.html',
  styleUrls: ['./application-list-stp.component.scss'],
})
export class ApplicationListStpComponent implements OnInit {
  applicationPermissions = applicationPermissions;
  stpApplicationDto: StpApplicationDto[] = [];

  searchingForm: FormGroup = this.fb.group({
    stpApplicationId: [null],
    stpIsApproved: [null],
    stpIsNotApproved: [null],
    currectionNeeded: [null],
    stpName: [null],
    stpOwnerShipStatusId: [null],
    sysDistrictId: [null],
    occupationName: [null],
    submissionStatusId: [null],
    pendingStp: [null],
    registrationNo: [null],
    // STP-side search: type of application and application id / registration no
    applicationType: [null],
    searchText: [null],
  });

  readonly applicationTypes = [
    { value: 'new', label: 'STP Registration' },
    { value: 'renewal', label: 'Renewal' },
    { value: 'reapply', label: 'Re-apply' },
  ];

  stpApplication: any;

  requestData: RequestData = new RequestData();
  userInfo: any;

  // for pagination
  total: number;
  size: number = 10;
  page: number = 1;
  // No default sort: the backend query is a UNION and already returns newest first.
  // A Spring Sort here becomes "order by d.id" and breaks that query.
  sortingKey: string;
  sortingValue: string;
  value: any = null;
  stpBasicData: any;
  // Set from the route: application | renewal | reapply | archive
  listType: 'application' | 'renewal' | 'reapply' | 'archive' = 'application';
  // True once the list has loaded, so "Start Application" isn't shown while the request is still running
  isListLoaded = false;

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private router: Router,
    private certificateService: CertificateService,
    private route: ActivatedRoute,
  ) {
    this.userId();
    this.listType = this.route.snapshot.data?.listType || 'application';
  }

  ngOnInit(): void {}

  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  get pageTitle(): string {
    switch (this.listType) {
      case 'renewal':
        return 'Renewal Application List';
      case 'reapply':
        return 'Reapply Application List';
      case 'archive':
        return 'Archive List';
      default:
        return 'Application List';
    }
  }

  loadStpApplicationsFromServer(): void {
    if (this.listType === 'archive') {
      this.loadArchiveApplications();
      return;
    }
    this.stpRegistrationStorageService
      .getStpApplicationListByUserId(
        this.page,
        this.size,
        this.sortingKey,
        this.sortingValue,
        this.requestData.id,
        {
          applicationType: this.searchingForm.value.applicationType,
          searchText: this.searchingForm.value.searchText,
        }
      )
      .subscribe({
        next: (res) => {
          const rows = Array.isArray(res?.data) ? res.data : [];
          this.stpApplicationDto = rows
            .filter((item: any) => this.belongsToList(item))
            .map((item: any) => {
              const expDate = new Date(item.expireDate);
              const today = new Date();
              const diffInDays = (expDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);
              return {
                ...item,
                isExpiringSoon: diffInDays > 0 && diffInDays <= 90,
              };
            });
          this.total = this.stpApplicationDto.length;
          this.isListLoaded = true;
        },
      });
  }

  // Application List: the STP's own application (approved, or the first one while pending) together with
  // its current renewal or reapply application (in progress, or Not Approved). The separate STP renewal /
  // reapply lists are gone (their routes redirect here), so 'renewal' / 'reapply' are no longer used.
  private belongsToList(item: any): boolean {
    const isDumpRow = item?.stpMainDumpId != null;
    switch (this.listType) {
      case 'renewal':
        return isDumpRow && item?.isRenewed === true;
      case 'reapply':
        return isDumpRow && item?.isReapplied === true;
      default:
        return true;
    }
  }

  private loadArchiveApplications(): void {
    this.stpRegistrationStorageService.getStpArchiveApplicationListForCurrentUser().subscribe({
      next: (res) => {
        this.stpApplicationDto = Array.isArray(res?.data) ? res.data : [];
        this.total = this.stpApplicationDto.length;
      },
      error: () => {
        this.stpApplicationDto = [];
        this.total = 0;
      },
    });
  }

  // downloadCertificate(stpId: number): void {
  //   this.stpRegistrationStorageService
  //     .getCertificateInformation(stpId)
  //     .subscribe((data: any) =>{
  //       var fileName = 'report.pdf';
  //       const contentDisposition = data.headers.get('Content-Disposition');
  //       if (contentDisposition) {
  //         const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //         const matches = fileNameRegex.exec(contentDisposition);
  //         if (matches != null && matches[1]) {
  //           fileName = matches[1].replace(/['"]/g, '');
  //         }
  //         FileSaver(data.body, fileName);
  //         {
  //           this.notification.success('Success!', "STP Certificate download completed");
  //         }
  //       }
  //     },
  //     (error) => {
  //       this.notification.error('Error!', "STP Certificate could not be downloaded");
  //     });
  // }

  downloadCertificate(stpId: number): void {
    this.stpRegistrationStorageService
      .getCertificateInformation(stpId)
      .subscribe({
        next: (response: ServerResponse) => {
          if (!response?.success) {
            this.notification.error(
              'Error',
              response?.message || 'Something went wrong!'
            );
            return;
          }
          this.certificateService.onDownloadSTPCertificate(response.data);
        },
        error: (error: any) => {
          console.error('API Error:', error);
          this.notification.error(
            'Error',
            'Certificate download failed due to missing or incomplete data. Please try again.'
          );
        },
      });
  }

  onSearch() {
    this.page = 1;
    this.size = 10;
    this.loadStpApplicationsFromServer();
  }

  onRefresh() {
    this.searchingForm.reset();
    this.onSearch();
  }

  // an empty list because of the search is not "no application yet"
  get hasActiveSearch(): boolean {
    const value = this.searchingForm.value;
    return !!value.applicationType || !!(value.searchText && String(value.searchText).trim());
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });

    this.loadStpApplicationsFromServer();
  }

  // Days until re-apply opens (the waiting period from the STP Setup page after the Not Approved
  // decision; the backend sends the date); 0 = it can re-apply now.
  // Worked out from today's date, so it counts down by one each day.
  reApplyDaysLeft(data: any): number {
    if (!data?.reApplyAllowedFrom) {
      return 0;
    }
    const [y, m, d] = String(data.reApplyAllowedFrom).substring(0, 10).split('-').map(Number);
    const allowedFrom = new Date(y, m - 1, d);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.max(0, Math.round((allowedFrom.getTime() - today.getTime()) / 86400000));
  }

  reApply(stpMainId: number) {
    this.stpRegistrationStorageService
      .reApplyStpApplication(stpMainId)
      .subscribe({
        next: (response) => {
          if (response?.success) {
            this.router.navigate(['home/stp-registration/renew-reapply-dash-board']);
          } else {
            this.notification.error('Error!', response?.message);
          }
        },
        error: (error) =>
          this.notification.error('Failed', error.error.message),
      });
  }

  renew(stpMainId: number) {
    this.stpRegistrationStorageService
      .renewStpApplication(stpMainId)
      .subscribe({
        next: (response) => {
          if (response?.success) {
            this.router.navigate(['home/stp-registration/renew-reapply-dash-board']);
          } else {
            this.notification.error('Error!', response?.message);
          }
        },
        error: (error) =>
          this.notification.error('Failed', error.error.message),
      });
  }

  isExpiringSoon(expireDate: string | Date): boolean {
    if (!expireDate) return false;
    const today = new Date();
    const exp = new Date(expireDate);
    const diffInMs = exp.getTime() - today.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    console.log('diffInDays:', diffInDays);

    return diffInDays > 0 && diffInDays <= 90;
  }

}
